<template>
  <select id="selectOption" @change="filter($event)">
    <option>Select an Option</option>
  </select>
</template>

<script>
import { verifyQuery, activityQuery } from "../indexedDB"
import { removeAccents } from "../generalFunctions"

// Import JQuery
var script = document.createElement("script")
script.src = "http://code.jquery.com/jquery-3.4.1.min.js"
script.type = "text/javascript"
document.getElementsByTagName("head")[0].appendChild(script)

// Variables Definition
var queryFilter = "categoryQuery"
var query = activityQuery
var field = "Activity.id"
var fieldFilter = "Activity.category"

export default {
  name: "FilterCategory",
  mounted() {
    var selectOption = document.getElementById("selectOption")
    var options = []
    var filterInfo
    const request = window.indexedDB.open("ioScience", window.version)
    request.onsuccess = function() {
      const db = request.result
      const transaction = db.transaction(queryFilter, "readwrite")
      const info = transaction.objectStore(queryFilter)
      const allInfo = info.getAll()
      allInfo.onsuccess = function() {
        filterInfo = allInfo.result
        for (var i = 0; i < filterInfo.length; i++) {
          options.push(filterInfo[i].value[fieldFilter])
          var opt = filterInfo[i].value[fieldFilter]
          var el = document.createElement("option")
          el.textContent = opt
          el.value = opt
          selectOption.appendChild(el)
        }
      }
    }
  },
  methods: {
    filter(event) {
      var queryName
      var selectedOption = event.target.value
      var askedQuery = query
      var filterQuery
      if (selectedOption !== "Select an Option") {
        filterQuery = { member: fieldFilter, operator: "equals", values: [selectedOption] }
        for (var k = 0; k < askedQuery.filters.length; k++) {
          if (askedQuery.filters[k].member === fieldFilter && askedQuery.filters[k].operator === "equals") {
            askedQuery.filters[k] = filterQuery
          }
        }
        if (!askedQuery.filters.includes(filterQuery)) {
          askedQuery.filters.push(filterQuery)
        }
        queryName =
          queryFilter + "_" + fieldFilter + "_" + removeAccents(selectedOption).replace(/[.,#!$%^&*;:{}=\-_`~() ]/g, "")
        var queryString = JSON.stringify(askedQuery)
        verifyQuery(queryName, queryString, field)
      } else {
        for (var j = 0; j < askedQuery.filters.length; j++) {
          if (askedQuery.filters[j].member === fieldFilter && askedQuery.filters[j].operator === "equals") {
            askedQuery.filters.pop(filterQuery)
            break
          }
        }
        queryName = queryFilter
      }
      this.$emit("selected", selectedOption)
    }
  }
}
</script>

<style scoped></style>
